import MdxImg from "../../../../src/components/shared/mdxImg";
import GalleryIcon from "../../../../src/images/svgs/gallery.svg";
import * as React from 'react';
export default {
  MdxImg,
  GalleryIcon,
  React
};